var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useEffect } from 'react';
import classnames from 'classnames/dedupe';
import { customAlphabet } from 'nanoid';
import { tokens } from '@servicetitan/tokens/core';
import { Popper } from '../../internal/Popper';
export const Tooltip = (_a) => {
    var { children, className, direction = 'top', el: TooltipElement = 'span', open: forceOpen = false, text, hoverOnly, tooltipClassName, onShow, onHide, underline = false } = _a, props = __rest(_a, ["children", "className", "direction", "el", "open", "text", "hoverOnly", "tooltipClassName", "onShow", "onHide", "underline"]);
    const [open, setOpen] = useState(false);
    const [reveal, setReveal] = useState(false);
    const [touch, setTouch] = useState(false);
    /* Delay prevents unintentional hover triggering */
    const delay = parseInt(tokens.durationSlow, 10); // '300ms' -> 300
    useEffect(() => {
        const timeout = setTimeout(() => {
            setOpen(!!reveal);
            !reveal && (onShow === null || onShow === void 0 ? void 0 : onShow());
            reveal && (onHide === null || onHide === void 0 ? void 0 : onHide());
        }, delay);
        return () => {
            clearTimeout(timeout);
        };
    }, [delay, onHide, onShow, reveal]);
    useEffect(() => {
        if (touch) {
            setOpen(touch);
            onShow === null || onShow === void 0 ? void 0 : onShow();
            const timeout = setTimeout(() => {
                setOpen(!touch);
                setTouch(!touch);
                onHide === null || onHide === void 0 ? void 0 : onHide();
            }, 1500);
            return () => {
                clearTimeout(timeout);
            };
        }
    }, [onHide, onShow, touch]);
    const handleShow = () => {
        setReveal(true);
    };
    const handleShowOnFocus = () => {
        if (!hoverOnly) {
            setReveal(true);
        }
    };
    const handleHide = () => {
        setReveal(false);
    };
    const handleTouch = () => {
        setTouch(true);
    };
    const getDirection = () => {
        if (direction === 'top')
            return 't';
        if (direction === 'topright')
            return 'tr';
        if (direction === 'topleft')
            return 'tl';
        if (direction === 'bottom')
            return 'b';
        if (direction === 'bottomright')
            return 'br';
        if (direction === 'bottomleft')
            return 'bl';
        if (direction === 'right')
            return 'r';
        if (direction === 'left')
            return 'l';
        return direction;
    };
    const tooltipVisible = text && (open || forceOpen);
    const describedby = props.id ||
        `tooltip_id_${customAlphabet('abcdefghijklmnopqrstuvwxyz', 8)()}`;
    const TooltipClasses = classnames('Tooltip', className, {
        'Tooltip--underline': !tooltipVisible && underline,
    });
    const TooltipBodyClasses = classnames('Tooltip__body', tooltipClassName, {
        [`Tooltip--${getDirection()}`]: getDirection(),
        'Tooltip__body--open': tooltipVisible,
    });
    return (React.createElement(Popper, Object.assign({ className: TooltipClasses, width: "auto", autoFlipVertically: true, onMouseEnter: handleShow, onMouseLeave: handleHide, onTouchStart: handleTouch, onFocus: handleShowOnFocus, onBlur: handleHide, direction: getDirection(), el: TooltipElement, open: tooltipVisible, trigger: React.createElement("span", { "aria-describedby": tooltipVisible ? describedby : undefined }, children), focusTrapOptions: { disabled: true }, caret: { show: true, className: 'Tooltip__caret' } }, props),
        React.createElement("span", { className: TooltipBodyClasses, role: "tooltip", tabIndex: -1, "aria-hidden": "true", id: describedby, "data-anvil-component": "Tooltip" }, text)));
};
//# sourceMappingURL=Tooltip.js.map